import { ServiceRequestApi } from '../ServiceRequestApi';
import Dict from '../../../modules/utils/Dict';
import Notice from '../../../modules/utils/Notice';
import i18next from 'i18next';
import moment from 'moment';
import { handleError } from '../../../modules/utils/handleError';
import { CONTINGENT_STATUS, DIRECTION_STATUS } from '../../../_helpers/Constants';

export const CheckChildInVoucherQueue = async (t, child_iin, queue_type) => {
  try {
    let check = false;

    const checkActiveQueue = await ServiceRequestApi.checkActiveQueue(
      child_iin,
      queue_type
    );

    if (
      checkActiveQueue.data.status === 'SUCCESS' &&
      checkActiveQueue.data.result.length > 0
    ) {
      for (let i = 0; i < checkActiveQueue.data.result.length; i++) {
        let item = checkActiveQueue.data.result[i];
        switch (item.appStatus) {
          case 'ON_CHECK':
            check = true;
            let app_status = await Dict.item('gu_app_status', item.appStatus);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err1', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                app_status: app_status[`${i18next.language}_name`]
              })
            );
            break;

          case 'ASSIGN_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err5', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                req_form_id: item.requestFormId,
                child_iin: item.childIin
              })
            );
            break;
          case 'IN_QUEUED':
            check = true;
            let q_type = await Dict.item('gu_queued_type', item.queuedType);
            let p_queued = await Dict.item('gu_priority_queued', item.priorityQueued);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err2', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                queued_type: q_type[`${i18next.language}_name`],
                priority_queued: p_queued[`${i18next.language}_name`]
              })
            );
            break;
          case 'WAITING_ASSIGN':
            check = true;
            let queue_type = await Dict.item('gu_queued_type', item.queuedType);
            let priority_queued = await Dict.item(
              'gu_priority_queued',
              item.priorityQueued
            );
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err2', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                queued_type: queue_type[`${i18next.language}_name`],
                priority_queued: priority_queued[`${i18next.language}_name`]
              })
            );
            break;

          case 'STOP_LIST_DC':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err4', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                deadline_stop_list: item.deadlineStopList
                  ? moment(item.deadlineStopList).format('DD.MM.YYYY')
                  : '__.__.____'
              })
            );
            break;

          case 'RECEIVED_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err6', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),

                req_form_id: item.requestFormId,
                child_iin: child_iin,
                id: item.id
              })
            );

            break;

          case 'WAITING_CONFIRM_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err5', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                req_form_id: item.requestFormId,
                child_iin: item.childIin
              })
            );

            break;
          default:
        }
        if (check) {
          break;
        }
      }
    } else {
      const voucher_res = await ServiceRequestApi.searchVoucherQueue(
        child_iin,
        queue_type
      );
      if (
        voucher_res.data.status === 'SUCCESS' &&
        voucher_res.data.result &&
        Object.keys(voucher_res.data.result).length !== 0
      ) {
        let voucher = voucher_res.data.result;

        switch (voucher.status) {
          case 'RECEIVED':
          case 'ARRIVED_TO_PO':
            if (voucher.requestFormId) {
              check = true;
              Notice.error(
                i18next.t('serviceRequest_check_in_queue_err6', {
                  fio:
                    (voucher?.childSurname || '') +
                    ' ' +
                    (voucher?.childName || '') +
                    ' ' +
                    (voucher?.childMiddleName || ''),

                  req_form_id: voucher.requestFormId,
                  child_iin: child_iin,
                  id: voucher.id
                })
              );
            }
            break;
        }
      } else {
        // проверям на наличие контингента
        let hasContingent = await ServiceRequestApi.getContingentCheck(child_iin);
        if (hasContingent.data.result.length > 0) {
          let item = hasContingent.data.result[0];
          switch (item.contingentStatus) {
            case DIRECTION_STATUS.ARRIVED_TO_PO:
              check = true;
              Notice.error(
                t('childInformationButton_arrivedDO', {
                  fio: item.childName + ' ' + item.childSurname,
                  child_iin: item.childIin
                })
              );
              break;
            case DIRECTION_STATUS.ENROLLED_TO_PO:
              check = true;
              Notice.error(
                t('childInformationButton_enrolledDO', {
                  fio: item.childName + ' ' + item.childSurname,
                  child_iin: item.childIin
                })
              );
              break;

            case CONTINGENT_STATUS.ENROLLED:
              check = true;
              Notice.error(
                t('childInformationButton_enrolledDO', {
                  fio: item.childName + ' ' + item.childSurname,
                  child_iin: item.childIin
                })
              );
              break;
            default:
          }
        }

        // Notice.error(i18next.t('serviceRequest_queue_type_check_req_err'));
      }
    }

    return check;
  } catch (e) {
    handleError(e, t('gbdflButton_searchFailed'));
    return false;
  }
};
